(() => {
  const STORES_SCRIPT_NAME = 'consumingPoints.js';

  /*
   * 初期化済みのSTORES blockを記録
   *
   * 同じblockに対して
   * consumingPoints.jsを2回実行しないため
   */
  const initializedStoresBlocks = new WeakSet();


  /*
   * 最初から存在するSTORES blockは、
   * STORES公式JSによって初期化済みなので記録
   */
  const initialStoresBlock = document.getElementById(
    'stores-consuming-points-block'
  );

  if (initialStoresBlock) {
    initializedStoresBlocks.add(initialStoresBlock);
  }


  /*
   * [STORES]ポイント利用を再初期化
   */
  const reinitializeStoresPoints = () => {
    return new Promise((resolve) => {
      const storesBlock = document.getElementById(
        'stores-consuming-points-block'
      );

      /*
       * App blockが存在しない
       */
      if (!storesBlock) {
        resolve();
        return;
      }


      /*
       * このDOMはすでに初期化済み
       */
      if (initializedStoresBlocks.has(storesBlock)) {
        resolve();
        return;
      }


      /*
       * 元々読み込まれているSTORES公式JSを探す
       */
      const originalScript = [...document.scripts].find(
        (script) =>
          script.src &&
          script.src.includes(STORES_SCRIPT_NAME)
      );

      if (!originalScript) {
        console.warn(
          '[STORES] consumingPoints.js not found'
        );

        resolve();
        return;
      }


      /*
       * 先に初期化済みとして記録
       *
       * MutationObserverとの二重実行を防止
       */
      initializedStoresBlocks.add(storesBlock);


      /*
       * STORES公式JSを再実行
       */
      const script = document.createElement('script');

      script.src = originalScript.src;
      script.async = true;


      script.onload = () => {
        script.remove();
        resolve();
      };


      script.onerror = () => {
        /*
         * 失敗した場合は再試行できるように戻す
         */
        initializedStoresBlocks.delete(storesBlock);

        script.remove();

        console.error(
          '[STORES] consumingPoints.js reload failed'
        );

        resolve();
      };


      document.head.appendChild(script);
    });
  };


  /*
   * Prestigeのcart drawer更新完了を待つ
   */
  const waitForCartRefresh = () => {
    return new Promise((resolve) => {
      const cartDrawer =
        document.getElementById('cart-drawer');

      if (!cartDrawer) {
        resolve();
        return;
      }

      let observer;
      let settleTimer;
      let fallbackTimer;


      const finish = () => {
        clearTimeout(settleTimer);
        clearTimeout(fallbackTimer);

        if (observer) {
          observer.disconnect();
        }

        resolve();
      };


      observer = new MutationObserver(() => {
        clearTimeout(settleTimer);

        /*
         * DOM変更が150ms止まったら
         * Prestige側の更新完了と判断
         */
        settleTimer = setTimeout(() => {
          finish();
        }, 150);
      });


      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });


      /*
       * 念のため最大2秒
       */
      fallbackTimer = setTimeout(() => {
        finish();
      }, 2000);
    });
  };


  /*
   * ========================================
   * SKU block
   * add to bag
   * ========================================
   */
  document.addEventListener(
    'click',

    async (event) => {
      const button =
        event.target.closest('.js-sku-add-to-cart');

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();


      if (button.disabled) {
        return;
      }


      const variantId =
        button.dataset.variantId;

      if (!variantId) {
        return;
      }


      button.disabled = true;


      try {

        /*
         * 商品追加
         */
        const response = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },

            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1
                }
              ]
            })
          }
        );


        if (!response.ok) {
          const error = await response.json();
          throw error;
        }


        await response.json();


        /*
         * Prestige更新監視を
         * refreshより先に開始
         */
        const refreshCompleted =
          waitForCartRefresh();


        /*
         * Prestige標準cart refresh
         */
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );


        /*
         * drawer更新完了待ち
         */
        await refreshCompleted;


        /*
         * 新しいSTORES blockを初期化
         */
        await reinitializeStoresPoints();


        /*
         * 最新のdrawerを取得
         */
        const cartDrawer =
          document.getElementById('cart-drawer');

        if (!cartDrawer) {
          console.error(
            'cart-drawer not found'
          );

          return;
        }


        /*
         * Prestige標準でdrawerを開く
         */
        requestAnimationFrame(() => {

          if (
            typeof cartDrawer.show === 'function'
          ) {
            cartDrawer.show();
            return;
          }


          if (
            typeof cartDrawer.open === 'function'
          ) {
            cartDrawer.open();
            return;
          }


          console.error(
            'cart-drawer show/open method not found'
          );

        });

      } catch (error) {

        console.error(
          'SKU add to cart error:',
          error
        );

      } finally {

        button.disabled = false;

      }
    },

    true
  );


  /*
   * ========================================
   * Prestige標準の
   * 数量変更・商品削除を監視
   * ========================================
   *
   * 新しいSTORES blockが生成された時だけ
   * 再初期化する
   */
  const storesObserver = new MutationObserver(
    (mutations) => {

      for (const mutation of mutations) {

        for (const node of mutation.addedNodes) {

          if (!(node instanceof Element)) {
            continue;
          }


          /*
           * stores blockそのものが追加された
           */
          if (
            node.id ===
            'stores-consuming-points-block'
          ) {
            reinitializeStoresPoints();
            return;
          }


          /*
           * 追加されたDOMの中に
           * stores blockがある
           */
          if (
            node.querySelector?.(
              '#stores-consuming-points-block'
            )
          ) {
            reinitializeStoresPoints();
            return;
          }

        }

      }

    }
  );


  /*
   * cart-drawer自体がPrestigeによって
   * 差し替えられる可能性も考慮しbodyを監視
   *
   * ただしSTORES block追加時しか
   * 処理しないので負荷は小さい
   */
  storesObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();